import $ from "jquery";

export const radioInputToggle = () => {
    $('input[name="SignUpQuestionForm[occupation]"]').on('click', function () {
        if ($(this).data('showQustion-2') === true) {
            $('#form-row-question-2').fadeIn();
            $('#form-row-question-2 .control-label').text($(this).data('labelQustion-2'));
        } else {
            $('#form-row-question-2').hide();
        }

        if ($(this).data('showQustion-3') === true) {
            $('#form-row-question-3').fadeIn();
            $('#form-row-question-3 .control-label').text($(this).data('labelQustion-3'));
        } else {
            $('#form-row-question-3').hide();
        }
    });
}
